<template>
  <div>
    <v-btn @click="openCreateDialog" color="primary">Nowy</v-btn>
    <data-table :items="users" :headers="headers">
      <template v-slot:item.isActive="{ item }">
        <v-switch
          :input-value="item.isActive"
          :loading="activeLoading"
          @change="toggleActive(item, $event)"
        ></v-switch>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="secondary"
          class="mr-1"
          @click="openTwoFactoryDialog(item)"
          >Uwierzytelnianie dwuskładnikowe</v-btn
        >
        <v-btn color="secondary" class="mr-1" @click="editCompanyUsers(item)"
          >Dostęp do wdrożeń</v-btn
        >
        <v-btn color="primary" class="mr-1" @click="openUpdateDialog(item)"
          >Edytuj</v-btn
        >
        <v-btn color="error" @click="openDeleteDialog(item)">Usuń</v-btn>
      </template>
    </data-table>
    <v-dialog v-model="createDialog" width="800" persistent>
      <v-card>
        <v-card-title> Nowy użytkownik </v-card-title>
        <v-card-text>
          <v-form v-model="createFormValid">
            <v-text-field
              label="Login"
              v-model="createVm.login"
              :rules="rules.login"
            ></v-text-field>
            <v-text-field
              label="Email"
              v-model="createVm.email"
              :rules="rules.email"
            ></v-text-field>
            <v-text-field
              label="Hasło"
              type="password"
              v-model="createVm.password"
              :rules="rules.password"
            ></v-text-field>
            <v-text-field
              label="Potwierdź hasło"
              type="password"
              v-model="createVm.confirmPassword"
              :rules="rules.confirmPassword"
            >
            </v-text-field>
            <v-select
              :items="roles"
              label="Rola użytkownika"
              v-model="createVm.userRole"
              :rules="rules.userRole"
            >
            </v-select
          ></v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="createUser"
            :disabled="!createFormValid"
            >Zapisz</v-btn
          >
          <v-btn color="error" @click="createDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="800" v-model="updateDialog" persistent>
      <v-card>
        <v-card-title> Edycja użytkownika </v-card-title>
        <v-card-text>
          <v-form v-model="updateFormValid" ref="updateForm">
            Id: {{ updateVm.id }}
            <v-text-field
              label="Login"
              v-model="updateVm.login"
              :rules="rules.login"
            ></v-text-field>
            <v-text-field
              label="Email"
              v-model="updateVm.email"
              :rules="rules.email"
            ></v-text-field>
            <v-select
              :items="roles"
              label="Rola użytkownika"
              v-model="updateVm.userRole"
              :rules="rules.userRole"
            >
            </v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="updateUser"
            :disabled="!updateFormValid"
            >Zapisz</v-btn
          >
          <v-btn color="error" @click="updateDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="800" v-model="deleteDialog" persistent>
      <v-card>
        <v-card-title> Usuń </v-card-title>
        <v-card-text
          ><v-row>
            <v-col>Login: {{ deleteVm.login }}</v-col>
            <v-col>Email: {{ deleteVm.email }} </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          ><v-btn color="primary" @click="deleteUser">Usuń</v-btn
          ><v-btn color="error" @click="deleteDialog = false">Anuluj</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="twoFactoryDialog" width="800" persistent>
      <v-card v-if="twoFactoryUserVm">
        <v-card-title> Uwierzytelnianie dwuskładnikowe </v-card-title>
        <v-card-text class="black--text">
          <div v-if="twoFactoryVm">
            Aby skorzystać z kodu pobierz aplikację, następnie zeskanuj poniższy
            kod w aplikacji
            <br />
            <br />
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=pl&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              ><img
                alt="pobierz z Google Play"
                width="200"
                height="50"
                src="@/assets/google_play.png"
            /></a>
            <a
              target="_blank"
              href="https://apps.apple.com/pl/app/google-authenticator/id388497605?l=pl"
              ><img
                alt="pobierz z App Store"
                width="200"
                height="50"
                src="@/assets/app_store.svg"
            /></a>
            <br />
            <strong>Kod QR do zeskanowania w aplikacji</strong>
            <v-img
              width="200"
              alt="kod_qr"
              :src="twoFactoryVm.imageUrl"
            ></v-img>
            <span
              >W przypadku problem ze skanowaniem kodu QR, możesz wprowadzić
              poniższy kod ręcznie: <br /><strong>{{
                twoFactoryVm.manualEntryCode
              }}</strong>
            </span>
            <br />
            <br />
            <span class="red--text">
              UWAGA! Jeżeli wygenerujesz nowy kod, aktywne kody oraz aplikacje
              przestną działać!
            </span>
          </div>
          <div v-if="loading">
            <v-progress-circular indeterminate size="50"></v-progress-circular>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="generateTwoFactoryCode"
            >Generuj nowy kod</v-btn
          >
          <v-btn color="error" @click="closeTwoFactoryDialog">Zamknij</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="changePasswordDialog" width="800" persistent>
      <v-card>
        <v-card-title> Zmiana hasła </v-card-title>
        <v-card-text>
          <v-form ref="changePasswordForm" v-model="changePasswordFormValid">
            <v-text-field
              v-model="changePasswordVm.password"
              label="Hasło"
              :rules="rules.password"
            ></v-text-field>

            <v-text-field
              v-model="changePasswordVm.confirmPassword"
              label="Potwierdź Hasło"
              :rules="rules.changeConfirmPassword"
            ></v-text-field
          ></v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="changePassword">Zapisz</v-btn
          ><v-btn color="error" @click="changePasswordDialog = false"
            >Anuluj</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataTable from "../components/DataTable.vue";
export default {
  components: {
    DataTable,
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Login",
          value: "login",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Rola",
          value: "userRole",
        },
        {
          text: "Aktywny",
          value: "isActive",
        },
        {
          text: "Opcje",
          value: "actions",
        },
      ],
      users: [],
      activeLoading: false,
      createDialog: false,
      deleteDialog: false,
      updateDialog: false,
      changePasswordDialog: false,
      deleteVm: {},
      createVm: {},
      updateVm: {},
      changePasswordVm: {},
      changePasswordFormValid: false,
      createFormValid: false,
      updateFormValid: false,
      twoFactoryDialog: false,
      twoFactoryUserVm: null,
      twoFactoryVm: null,
      roles: [
        {
          value: 1,
          text: "Pracownik wdrożenia",
        },
        {
          value: 2,
          text: "Administrator",
        },
      ],
      rules: {
        login: [
          (v) => !!v || "Login wymagany",
          (v) => (v && v.length >= 4) || "Minimalna długość to 4 znaki",
        ],
        email: [
          (v) => !!v || "Email wymagany",
          (v) => /.+@.+\..+/.test(v) || "To nie jest email",
        ],
        password: [
          (v) => !!v || "Hasło wymagane",
          (v) => (v && v.length >= 8) || "Minimalna długość to 8 znaków",
        ],
        confirmPassword: [
          (v) => v == this.createVm.password || "Hasła nie są takie same",
        ],
        changeConfirmPassword: [
          (v) =>
            v == this.changePasswordVm.confirmPassword ||
            "Hasła nie są takie same",
        ],
        userRole: [(v) => !!v || "Rola wymagana"],
      },
    };
  },
  methods: {
    async downloadTwoFactoryCode() {
      try {
        this.loading = true;
        const { data } = await this.$http.get(
          "Authentication/DownloadTwoFactoryCode?userId=" +
            this.twoFactoryUserVm.id
        );
        this.twoFactoryVm = data;
      } finally {
        this.loading = false;
      }
    },
    async generateTwoFactoryCode() {
      try {
        this.loading = true;
        const { data } = await this.$http.post(
          "Authentication/SetupTwoFactorAuthentication",
          { userId: this.twoFactoryUserVm.id }
        );
        this.twoFactoryUserVm.hasSetupTwoFactor = true;
        this.twoFactoryVm = data;
      } finally {
        this.loading = false;
      }
    },
    closeTwoFactoryDialog() {
      this.twoFactoryDialog = false;
      this.twoFactoryUserVm = null;
      this.twoFactoryVm = null;
    },
    async openTwoFactoryDialog(item) {
      this.twoFactoryUserVm = item;
      this.twoFactoryDialog = true;
      if (this.twoFactoryUserVm.hasSetupTwoFactor) {
        this.$nextTick(() => {
          this.downloadTwoFactoryCode();
        });
      }
    },
    async toggleActive(user, value) {
      this.activeLoading = true;
      try {
        if (value) {
          await this.$http.post("User/EnableUser", {id :user.id});
          user.isActive = true;
        } else {
          await this.$http.post("User/DisableUser", {id :user.id});
          user.isActive = false;
        }
      }
      finally {
        this.activeLoading = false;
      }
    },
    async getUsers() {
      const response = await this.$http.get("User/Get");
      this.users = response.data;
    },
    openCreateDialog() {
      this.createVm = {};
      this.createDialog = true;
    },
    async createUser() {
      if (!this.createFormValid) {
        return;
      }
      const response = await this.$http.post("User/Create", this.createVm);
      this.users.push(response.data);
      this.createDialog = false;
    },
    openDeleteDialog(item) {
      this.deleteVm = item;
      this.deleteDialog = true;
    },
    async deleteUser() {
      await this.$http.delete("User/Delete?id=" + this.deleteVm.id);
      const indexOf = this.users.indexOf(this.deleteVm);
      this.users.splice(indexOf, 1);
      this.deleteDialog = false;
    },
    openChangePasswordDialog(item) {
      this.changePasswordVm = { id: item.id };
      this.changePasswordDialog = true;
    },
    async changePassword() {
      if (!this.changePasswordFormValid) {
        return;
      }
      await this.$http.post("User/ChangePassword", this.changePasswordVm);
    },
    openUpdateDialog(item) {
      this.updateVm = JSON.parse(JSON.stringify(item));
      this.updateDialog = true;
    },
    async updateUser() {
      if (!this.updateFormValid) {
        return;
      }
      const response = await this.$http.post("User/Update", this.updateVm);
      const find = this.users.find((el) => el.id == this.updateVm.id);
      const indexOf = this.users.indexOf(find);
      this.users.splice(indexOf, 1, response.data);
      this.updateDialog = false;
    },
    editCompanyUsers(item) {
      this.$router.push({ path: "/CompanyUsers/" + item.id });
    },
  },
  computed: {},
  async mounted() {
    await this.getUsers();
  },
};
</script>

<style></style>
